import { FormHelperText } from "@mui/material";
import { ReactNode } from "react";
import { ValidationErrors } from "../../../hooks";
import { Box, InputLabel } from "../../mui";
import { displayErrorMessages, getErrorMessages } from "../input-functions";

type RichTextReaderProps = {
  label?: ReactNode;
  required?: boolean;
  errors?: ValidationErrors | string[];
  customStyles?: any;
  html: string | undefined;
};

export const RichTextReader = (props: RichTextReaderProps) => {
  const errorMsg = getErrorMessages(props.errors);
  const hasError = errorMsg.length > 0;

  return (
    <Box>
      {props.label && (
        <InputLabel error={hasError} required={props.required} shrink={true}>
          {props.label}
        </InputLabel>
      )}
      <Box
        sx={{
          ...props.customStyles,
          img: { maxWidth: "100% !important" },
          'table': { borderCollapse: "collapse" },
          'td': {
            border: '1px solid #ccc',
            padding: 1.2
          },
        }}
        dangerouslySetInnerHTML={{ __html: props.html! }}
      ></Box>
      {hasError && <FormHelperText error>{displayErrorMessages(errorMsg)}</FormHelperText>}
    </Box>
  );
};
